import { Col, DatePicker, Form, Input, Modal, Row, Select, Switch } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

const { Option } = Select;

const EditLeavePolicyModal = ({
  visible,
  onCancel,
  onOk,
  initialValues,
  leaveTypes,
  loading
}) => {
  const [form] = Form.useForm();
  const [creditType, setCreditType] = useState('');

  useEffect(() => {
    if (initialValues) {
      console.log('Initial values:', initialValues);
      const formattedValues = {
        ...initialValues,
        leaveTypeId: initialValues.leaveTypeId,
        validFrom: initialValues.validFrom ? dayjs(initialValues.validFrom) : null,
        validTo: initialValues.validTo ? dayjs(initialValues.validTo) : null,
        unit: initialValues.unit ? 'hours' : 'days',
        credit: initialValues.credit ? 'monthly' : 'annually',
      };
      form.setFieldsValue(formattedValues);
      setCreditType(initialValues.credit ? 'monthly' : 'annually');
    }
  }, [initialValues, form]);

  const handleCreditChange = (e) => {
    setCreditType(e.target.value);
  };

  const handleOk = () => {
    form.validateFields()
      .then((values) => {
        const formattedValues = {
          ...values,
          // yearlyLimit: values.yearlyLimit.toString(),
          // creditLimit: values.creditLimit.toString(),
          // monthlyLimit: values.monthlyLimit.toString(),
          // unit: values.unit === 'days' ? false : true,
          // credit: values.credit === 'annually' ? false : true,
          // validFrom: values.validFrom ? values.validFrom.toISOString() : null,
          // validTo: values.validTo ? values.validTo.toISOString() : null,
          paid: values.paid || false,
          limit: values.limit || false,

          // carryForward: values.carryForward || false,
          // encashable: values.encashable || false,
        };
        onOk(formattedValues);
      })
      .catch((error) => {
        console.log('Validation failed:', error);
      });
  };

  return (
    <Modal
      title="Edit Leave Policy"
      visible={visible}
      onCancel={onCancel}
      onOk={handleOk}
      width={800}
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout="vertical"
      >

         <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter the name!' }]}
        >
          <Input placeholder="Enter name" />
        </Form.Item>
        {/* <Form.Item label="Leave Type">
          <Input value={initialValues.leaveType?.leaveType || 'N/A'} disabled />
        </Form.Item> */}

        {/* <Form.Item
          name="yearlyLimit"
          label="Max Leaves Per Year"
          rules={[{ required: true, message: 'Please enter the leave limit!' }]}
        >
          <InputNumber min={0} placeholder="Enter number of days" />
        </Form.Item>

        <Form.Item
          name="monthlyLimit"
          label="Max Leaves Per Month"
          rules={[{ required: true, message: 'Please enter the leave limit!' }]}
        >
          <InputNumber min={0} placeholder="Enter number of days" />
        </Form.Item>

        <Form.Item
          name="unit"
          label="Unit"
          rules={[{ required: true, message: 'Please select a unit!' }]}
        >
          <Radio.Group>
            <Radio value="days">Days</Radio>
            <Radio value="hours">Hours</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="credit"
          label="Credit"
          rules={[{ required: true, message: 'Please select a credit type!' }]}
        >
          <Radio.Group onChange={handleCreditChange}>
            <Radio value="annually">Annually</Radio>
            <Radio value="monthly">Monthly</Radio>
          </Radio.Group>
        </Form.Item>

        {creditType === 'monthly' && (
          <Form.Item
            name="creditLimit"
            label="Monthly Credit Value"
            rules={[{ required: true, message: 'Please enter the monthly credit value!' }]}
          >
            <InputNumber min={0} placeholder="Enter number of days per month" />
          </Form.Item>
        )}

        {creditType === 'annually' && (
          <Form.Item
            name="creditLimit"
            label="Annual Credit Value"
            rules={[{ required: true, message: 'Please enter the annual credit value!' }]}
          >
            <InputNumber min={0} placeholder="Enter number of days per year" />
          </Form.Item>
        )}

         */}

        <Row gutter={16}>
        <Col span={8}>
            <Form.Item name="limit" label="Limit" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="paid" label="Is Paid Leave" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
          {/* <Col span={8}>
            <Form.Item name="carryForward" label="Allow Carry Forward" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="encashable" label="Encashable" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col> */}

<Form.Item label="Validity:">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="validFrom"
                label="From Date"
                rules={[{ required: true, message: 'Please select the start date!' }]}
              >
                <DatePicker placeholder="Select start date" style={{ width: '100%' }} disabled/>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="validTo"
                label="To Date"
                rules={[{ required: true, message: 'Please select the end date!' }]}
              >
                <DatePicker placeholder="Select end date" style={{ width: '100%' }} disabled/>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditLeavePolicyModal;